import React, { useEffect } from 'react';
import { Header } from 'pages/Header';
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito';
import './style.sass';
import { Error500 } from 'components/Error/Error500';
import AceptarCreditoCS from '../AceptarCreditoCS';

export default function HomeMobile(props) {

    const {
        errorCode,
        creditoAutorizado,
        isMobile,
        aceptarCredito,
        loading
    } = props

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="homeMobile">
            <Header type="complete" />
            <HeaderMobileCredito title="Mi crédito Claroshop" type="backFull" valToken={false} /> {/* btnTypeR="whats" /> */}
            {errorCode >= 500
                ? <Error500 />
                : <div className="contenedorGeneral homeC">
                    {!loading
                        ?<AceptarCreditoCS creditoAutorizado={creditoAutorizado} isMobile={isMobile} aceptarCredito={aceptarCredito} />
                        :null
                    }
                </div>
            }
        </div>
    )
}